import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NavItemModel, NavItemTranslateCodes } from '@core/models/nav-item.model';
import { RouteEntity } from '@core/router/router.entity';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-navbar-mobile',
    templateUrl: './navbar-mobile.component.html',
    styleUrls: ['./navbar-mobile.component.scss'],
    standalone: true,
    imports: [MatIconModule, RouterLink, TranslateModule],
})
export class NavbarMobileComponent {
    public readonly navItemList: NavItemModel[] = [
        {
            path: [RouteEntity.Root, RouteEntity.Tickets],
            title: NavItemTranslateCodes.get(RouteEntity.Tickets),
            icon: 'sell',
        },
        {
            path: [RouteEntity.Root, RouteEntity.Medium],
            title: NavItemTranslateCodes.get(RouteEntity.Medium),
            icon: 'credit_card',
        },
        {
            path: [RouteEntity.Root, RouteEntity.Person],
            title: NavItemTranslateCodes.get(RouteEntity.Person),
            icon: 'person',
        },
        {
            path: [RouteEntity.Root, RouteEntity.Logout],
            title: NavItemTranslateCodes.get(RouteEntity.Logout),
            icon: 'logout',
        },
    ];
}
